/**
 * Recalcula la ventana de entrega en el navegador.
 *
 * Liquid ya la pinta al renderizar, pero Shopify cachea la página de producto
 * y la fecha se quedaría congelada de un día para otro. Aquí se vuelve a
 * calcular con la fecha del cliente, que es la que él considera "hoy".
 */
(() => {
  const MESES = [
    'enero', 'febrero', 'marzo', 'abril', 'mayo', 'junio',
    'julio', 'agosto', 'septiembre', 'octubre', 'noviembre', 'diciembre',
  ];

  const sumarDias = (dias) => {
    const d = new Date();
    d.setHours(12, 0, 0, 0);        // mediodía: esquiva los saltos de horario
    d.setDate(d.getDate() + dias);
    return d;
  };

  const redactar = (dias_min, dias_max) => {
    const a = sumarDias(dias_min);
    const b = sumarDias(dias_max);
    if (a.getMonth() === b.getMonth()) {
      return `entre el ${a.getDate()} y el ${b.getDate()} de ${MESES[b.getMonth()]}`;
    }
    return `entre el ${a.getDate()} de ${MESES[a.getMonth()]} `
         + `y el ${b.getDate()} de ${MESES[b.getMonth()]}`;
  };

  const pintar = (lista) => {
    const hueco = lista.querySelector('[data-pe-rango]');
    if (!hueco) return;
    const min = parseInt(lista.dataset.diasMin, 10);
    const max = parseInt(lista.dataset.diasMax, 10);
    if (!Number.isFinite(min) || !Number.isFinite(max)) return;
    const texto = redactar(min, max);
    if (hueco.textContent.trim() !== texto) hueco.textContent = texto;
  };

  const repasar = () => document.querySelectorAll('[data-pico-envios]').forEach(pintar);

  repasar();
  // El editor de temas reinyecta el bloque al cambiar un ajuste.
  document.addEventListener('shopify:section:load', repasar);
})();
